var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.user_label === 'Admin Stayted')?_c('b-badge',{staticStyle:{"opacity":"0.6"},attrs:{"variant":"secondary"}},[_vm._v("importer")]):(_vm.user_label !== 'Admin Stayted')?_c('span',[_vm._v(_vm._s(_vm.user_label))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }